/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateKpiDefinitionRequestBody
 */
export interface CreateKpiDefinitionRequestBody {
    /**
     * 
     * @type {string}
     * @memberof CreateKpiDefinitionRequestBody
     */
    kpiKey: string;
    /**
     * 
     * @type {string}
     * @memberof CreateKpiDefinitionRequestBody
     */
    displayName: string;
    /**
     * 
     * @type {string}
     * @memberof CreateKpiDefinitionRequestBody
     */
    unit?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateKpiDefinitionRequestBody
     */
    direction?: string;
    /**
     * 
     * @type {number}
     * @memberof CreateKpiDefinitionRequestBody
     */
    targetValue?: number;
    /**
     * 
     * @type {number}
     * @memberof CreateKpiDefinitionRequestBody
     */
    warningValue?: number;
    /**
     * 
     * @type {number}
     * @memberof CreateKpiDefinitionRequestBody
     */
    breachValue?: number;
    /**
     * 
     * @type {string}
     * @memberof CreateKpiDefinitionRequestBody
     */
    sourceModule?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateKpiDefinitionRequestBody
     */
    sourceRef?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateKpiDefinitionRequestBody
     */
    notes?: string;
}

/**
 * Check if a given object implements the CreateKpiDefinitionRequestBody interface.
 */
export function instanceOfCreateKpiDefinitionRequestBody(value: object): value is CreateKpiDefinitionRequestBody {
    if (!('kpiKey' in value) || value['kpiKey'] === undefined) return false;
    if (!('displayName' in value) || value['displayName'] === undefined) return false;
    return true;
}

export function CreateKpiDefinitionRequestBodyFromJSON(json: any): CreateKpiDefinitionRequestBody {
    return CreateKpiDefinitionRequestBodyFromJSONTyped(json, false);
}

export function CreateKpiDefinitionRequestBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateKpiDefinitionRequestBody {
    if (json == null) {
        return json;
    }
    return {
        
        'kpiKey': json['kpiKey'],
        'displayName': json['displayName'],
        'unit': json['unit'] == null ? undefined : json['unit'],
        'direction': json['direction'] == null ? undefined : json['direction'],
        'targetValue': json['targetValue'] == null ? undefined : json['targetValue'],
        'warningValue': json['warningValue'] == null ? undefined : json['warningValue'],
        'breachValue': json['breachValue'] == null ? undefined : json['breachValue'],
        'sourceModule': json['sourceModule'] == null ? undefined : json['sourceModule'],
        'sourceRef': json['sourceRef'] == null ? undefined : json['sourceRef'],
        'notes': json['notes'] == null ? undefined : json['notes'],
    };
}

export function CreateKpiDefinitionRequestBodyToJSON(json: any): CreateKpiDefinitionRequestBody {
    return CreateKpiDefinitionRequestBodyToJSONTyped(json, false);
}

export function CreateKpiDefinitionRequestBodyToJSONTyped(value?: CreateKpiDefinitionRequestBody | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'kpiKey': value['kpiKey'],
        'displayName': value['displayName'],
        'unit': value['unit'],
        'direction': value['direction'],
        'targetValue': value['targetValue'],
        'warningValue': value['warningValue'],
        'breachValue': value['breachValue'],
        'sourceModule': value['sourceModule'],
        'sourceRef': value['sourceRef'],
        'notes': value['notes'],
    };
}

